export default "__VITE_ASSET__c5SHfWF1__"